module.exports = __webpack_public_path__ + "static/iPadDashboardOrder-8d6067c978458c26cfcbc54b75c56fc8.png";